import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SellerDashboardService {

    constructor(private _http: HttpClient) { }

    dashboarddetails(data) {
        return this._http.post(environment.api_url+'seller/dashboard',data);
    }

    dashboardmonths(data) {
        return this._http.post(environment.api_url+'seller/dashboard/filter',data);
    }

}
